import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import "./PricingSection4.scss";

function PricingSection4(props) {
  const plans = [
    {
      id: "accountable-ai",
      image: "/ai_graphic1.svg",
      name: "Accountable AI",
      perks: [
        "Protect your company's IP from unauthorized usage by LLMs and GPT applications",
        "Set your own price and terms of use",
        "Receive royalties for usage (identified via output similarity matching)"
      ],
      link: "https://ai-image-demo-v2.fly.dev/login"
    },
    {
      id: "royalty-trees",
      image: "/app_graphic1.svg",
      name: "Royalty Trees",
      perks: [
        "Track and manage royalty payments for data/IP assets in internal/external data exchange processes.",
        "Use PDS to manage data rights/licenses for media IP and financial market data.",
      ],
      link: "https://royaltytrees.fly.dev/"
    },
    {
      id: "flow",
      image: "/app_graphic1.svg",
      name: "Flow NFT Upcycle",
      perks: [
        "Convert Flow NFTs into Żetonium pNFTs with associated PDS licensing and royalties functionality.",
      ],
      link: "https://flow-demo.fly.dev/"
    },
  ];

  return (
    <Section
      id="pricing2"
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
      <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          spaced={true}
          className="has-text-centered"
        />
        <div className="columns is-centered is-variable is-4 is-desktop">
          {plans.map((plan, index) => (
            <div
              className="PricingSection4__column column is-one-third-desktop"
              key={index}
            >
              <div className="PricingSection4__card card">
                <div className="PricingSection4__card-content card-content">
                  <div className="PricingSection4__image-container image">
                    <img className="PricingSection4__image"
                      src={plan.image} alt="Logo" 
                    />
                  </div>
                  <br />
                  <div className="PricingSection4__name has-text-weight-bold">
                    {plan.name}
                  </div>

                  {plan.description && (
                    <p className="PricingSection4__description">
                      {plan.description}
                    </p>
                  )}

                  {plan.perks && (
                    <ul className="PricingSection4__perks">
                      {plan.perks.map((perk, index) => (
                        <li key={index}>
                          <i className="fas fa-check has-text-primary" />
                          {perk}
                        </li>
                      ))}
                    </ul>
                  )}
                  <a
                    className="PricingSection4__button button is-medium is-primary"
                    href={plan.link}
                  >
                    Check it out
                  </a>
                </div>
                </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}

export default PricingSection4;
